// Meta Pixel (factory.online). The base snippet loads only after advertising
// consent is granted — or immediately for visitors outside consent regions.
const PIXEL_ID = "1032689143111284";

type Fbq = ((...args: unknown[]) => void) & {
  queue?: unknown[][];
  loaded?: boolean;
  version?: string;
  callMethod?: (...args: unknown[]) => void;
};

let loaded = false;

function fbq(): Fbq | undefined {
  return (window as unknown as { fbq?: Fbq }).fbq;
}

export function loadMetaPixel() {
  if (loaded) return;
  loaded = true;
  const w = window as unknown as { fbq?: Fbq; _fbq?: Fbq };
  if (!w.fbq) {
    const n = function (...args: unknown[]) {
      if (n.callMethod) n.callMethod(...args);
      else n.queue!.push(args);
    } as Fbq;
    n.queue = [];
    n.loaded = true;
    n.version = "2.0";
    w.fbq = n;
    w._fbq = n;
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(s);
  }
  w.fbq!("init", PIXEL_ID);
  w.fbq!("track", "PageView");
}

export function grantMetaConsent() {
  const f = fbq();
  if (f) f("consent", "grant");
}

export function revokeMetaConsent() {
  const f = fbq();
  if (f) f("consent", "revoke");
}

// Fires the standard Lead event after a request form is successfully sent.
// No-op when the pixel is not loaded (consent denied or not required path
// not yet initialized).
export function trackLead() {
  const f = fbq();
  if (!loaded || !f) return;
  f("track", "Lead", {}, { eventID: crypto.randomUUID() });
}
